import React, { useState, useEffect } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import icTitle from "../../../assets/images/ic-play.svg";
import ENGModalBody from "../../../components/modal/ENGModalBody";
import ENGModalHeader from "../../../components/modal/ENGModalHeader";
import {
  GetFormattedDate,
} from "../../../constant/DateFormatEdit";
import ApproveRejectDeclaration from "./ApproveRejectDeclaration";
import { useAppSelector } from "../../../app/hooks";
import {
  selectCOIChatList,
  selectUpdateDeclarationStatus,
} from "../../../features/helpandassistance/DeclarationSlice";
import { isPermited } from "../../../features/localStorage";
import { dev } from "../../../features/network/ApiCall";
import DeclarationComments from "./DeclarationComments";

const DeclarationDetails = ({
  icon = icTitle,
  records,
  GetDeclarationType,
  type
}: {
  icon?: any;
  records?: any;
  GetDeclarationType?: any;
  type?: string;
}) => {
  const changeStatus = useAppSelector(selectUpdateDeclarationStatus);
  const chatList = useAppSelector(selectCOIChatList);
  const [modalShow, setModalShow] = useState(false);

  const handleClose = () => setModalShow(false);
  const handleShow = () => setModalShow(true);

  useEffect(() => {
    handleClose();
  }, [chatList]);

  const Show = (label: string, value: any, sm: number = 3) => {
    return (
      <Col xs={12} sm={sm} className='mt-2'>
        <div style={styles.label}>{label}</div>
        <div style={styles.value}>{value ? value : '-'}</div>
      </Col>
    );
  };

  const GetStatus = (status: any) => {
    if (status == 0) return <div style={{ color: '#ffbf00' }}>PENDING</div>;
    if (status == 1) return <div style={{ color: '#00aa00' }}>APPROVED</div>;
    if (status == 2) return <div style={{ color: '#e31837' }}>REJECTED</div>;
    if (status == 3) return <div style={{ color: '#e31837' }}>SEND BACK</div>;
  };

  let files: any = records?.fileName ? records?.fileName.split(',') : [];

  return (
    <>
      <a
        onClick={handleShow}
        style={{
          backgroundColor: '#fff',
          color: '#e31837',
          fontFamily: 'Saira',
          fontWeight: 600,
          fontSize: '12px',
          textTransform: 'uppercase',
          // paddingTop: '10px',
          paddingRight: '8px',
          cursor: 'pointer'
        }}
      >
        View
      </a>

      <Modal
        show={modalShow}
        onHide={handleClose}
        backdrop='static'
        // size="lg"
        fullscreen={true}
        keyboard={false}
      >
        <ENGModalHeader icon={icon} title='Declaration Details' />
        <ENGModalBody
          contents={
            <>
              <Row style={styles.divWhite}>
                {Show('Name', records?.name)}
                {Show('Token No.', records?.employeeId)}
                {Show('Designation', records?.designation)}
                {/* {Show('Sector', records?.sectorName)} */}
                {/* {Show('Department', records?.dept)} */}
                {Show('Location', records?.location)}
                {Show('Line Manager', records?.managerName)}
                {/* {Show('Office Phone', records?.officePhone)} */}
                {Show(
                  'Created On',
                  GetFormattedDate(records?.createdDate, 'DD-MM-YYYY')
                )}
                {Show('COI Sector', records?.coiSectorName)}
                {/* {Show('Conflict Type', records?.declearationCategoryType)} */}
                {Show(
                  'Conflict Category',
                  records?.conflictCategoryMasterTitle,
                  12
                )}
                {Show('Status', GetStatus(records?.status))}
                {Show('Particular Matter', records?.perticularMatter, 12)}
                {files.length > 0 && (
                  <Col xs={12} style={{ marginTop: 10 }}>
                    <div style={styles.label}>Attachments</div>
                    {files.map((file: string, index: any) => {
                      return (
                        <>
                          <a
                            href={`${dev}/fileUpload/downloadFile?file=${file}`}
                            style={{ color: 'blue' }}
                          >
                            {file}
                          </a>
                          <br />
                        </>
                      );
                    })}
                  </Col>
                )}
                {/* {(records?.status == 1 || records?.status == 2) &&
                  Show('Remark', records?.remark)} */}
              </Row>
              {/* {type === "pending" && ( */}
              <ApproveRejectDeclaration
                dataObj={records}
                type={type}
                statusId={records?.status}
              />
              {/* )} */}
              {records?.chatFunctionalities?.length > 0 && (
                <Row>
                  <Col sm={12}>
                    <DeclarationComments
                      comments={records?.chatFunctionalities}
                    />
                  </Col>
                </Row>
              )}
            </>
          }
        />
      </Modal>
    </>
  );
};

const styles: any = {
  divWhite: {
    backgroundColor: "#fffff",
    padding: "20px",
  },
  label: {
    fontFamily: "Saira",
    fontSize: "14px",
    fontWeight: "600",
    fontStrech: "normal",
    textAlign: "left",
  },
  value: {
    fontFamily: "Saira",
    fontSize: "16px",
    fontWeight: "normal",
    fontStrech: "normal",
    textAlign: "left",
  },
};

export default DeclarationDetails;
